"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("../../components/Modal"));
var _ModalHeader = _interopRequireDefault(require("../../components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("../../components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("../../components/ModalFooter"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _h;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  collection: [],
  theme: {}
};

/**
 * Component that displays the active environment
 * and provides a way to change it.
 */
var EnvSwitcher = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(EnvSwitcher, _Component);
  function EnvSwitcher(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, EnvSwitcher);
    /** If collection is not empty, first item is default*/
    var defaultEnvironment = props.collection.length ? props.collection[0].id : null;
    _this = _callSuper(this, EnvSwitcher, [props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOpen", function () {
      _this.setState({
        tempActiveEnv: _this.props.activeEnv || _this.state.defaultEnv,
        isModalOpen: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDismiss", function () {
      _this.setState({
        isModalOpen: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function () {
      var onChange = _this.props.onChange;
      var tempActiveEnv = _this.state.tempActiveEnv;
      _this.setState({
        isModalOpen: false
      });
      if (onChange) {
        onChange({
          value: tempActiveEnv
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderItem", function (env, index) {
      var _this$props = _this.props,
        activeEnv = _this$props.activeEnv,
        defaultEnv = _this$props.defaultEnv,
        theme = _this$props.theme,
        testId = _this$props.testId;
      var tempActiveEnv = _this.state.tempActiveEnv;

      // if activeEnv is passed to the props, we will use it for comparing,
      // else we will compare with defaultEnv from state
      var isActiveEnv = env.id === (activeEnv || defaultEnv);
      // If user has selected some item from the list, we will compare with tempActiveEnv from state,
      // else we will mark as selected the current active env (activeEnv)
      var isSelectedEnv = env.id === (tempActiveEnv || activeEnv);
      var isDefaultEnv = env.id === defaultEnv;
      return /*#__PURE__*/_react["default"].createElement("button", {
        "data-test-id": testId && "".concat(testId, "-").concat(env.name, "-env-item"),
        onClick: function onClick() {
          return _this.setState({
            tempActiveEnv: env.id
          });
        },
        onDoubleClick: _this.handleSubmit,
        className: (0, _classnames["default"])(theme.envItem, isSelectedEnv && theme.active),
        key: index,
        title: env.name
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: theme.envItemTitle
      }, env.name), isActiveEnv && /*#__PURE__*/_react["default"].createElement("span", {
        "data-test-id": "active-env-label",
        className: (0, _classnames["default"])(theme.mark, theme.markActive)
      }, "Active"), isDefaultEnv && /*#__PURE__*/_react["default"].createElement("span", {
        "data-test-id": "default-env-label",
        className: (0, _classnames["default"])(theme.mark, theme.markDefault)
      }, "Default"));
    });
    _this.state = {
      isModalOpen: _this.props.isOpen || false,
      defaultEnv: defaultEnvironment
    };
    return _this;
  }
  (0, _createClass2["default"])(EnvSwitcher, [{
    key: "renderModal",
    value: function renderModal() {
      var _this$props2 = this.props,
        collection = _this$props2.collection,
        profileUrl = _this$props2.profileUrl,
        theme = _this$props2.theme,
        testId = _this$props2.testId,
        noAvailableEnvMsg = _this$props2.noAvailableEnvMsg;
      var noEnvMessage = noAvailableEnvMsg || 'No available environments';
      var isCollectionEmpty = collection.length === 0;
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        onEnter: this.handleSubmit,
        onEsc: this.handleDismiss,
        onClickOverlay: this.handleDismiss,
        theme: this.props.theme.Modal,
        className: theme.modal,
        testId: "environment-switcher-modal"
      }, /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
        theme: this.props.theme.ModalHeader
      }, _h || (_h = /*#__PURE__*/_react["default"].createElement("h1", null, "Switch Environment"))), /*#__PURE__*/_react["default"].createElement(_ModalBody["default"], {
        theme: this.props.theme.ModalBody,
        className: theme.modalBody
      }, isCollectionEmpty ? /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": "environment-switcher-message",
        className: theme.noEnvMessage
      }, noEnvMessage) : collection.map(this.renderItem)), /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], {
        theme: this.props.theme.ModalFooter,
        className: theme.modalFooter
      }, profileUrl && /*#__PURE__*/_react["default"].createElement("a", {
        "data-test-id": "".concat(testId, "-anchor"),
        className: theme.anchor,
        href: profileUrl
      }, "Open your profile to change the default environment..."), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        kind: "tertiary",
        testId: testId && "".concat(testId, "-cancel"),
        onClick: this.handleDismiss,
        noFill: true,
        theme: this.props.theme.Button
      }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        kind: "primary",
        disabled: isCollectionEmpty,
        testId: testId && "".concat(testId, "-switch-env"),
        onClick: this.handleSubmit,
        theme: this.props.theme.Button
      }, "Switch")));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        collection = _this$props3.collection,
        activeEnv = _this$props3.activeEnv,
        theme = _this$props3.theme,
        className = _this$props3.className,
        testId = _this$props3.testId;
      var _this$state = this.state,
        isModalOpen = _this$state.isModalOpen,
        defaultEnv = _this$state.defaultEnv;
      var currentEnv = activeEnv || defaultEnv;
      var activeEnvName = currentEnv && defaultEnv ? collection.find(function (env) {
        return env.id === currentEnv;
      }).name : 'N/A';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(theme.envSwitcher, className),
        "data-anypoint-component": EnvSwitcher.displayName,
        "data-test-id": testId
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: theme.envButton,
        onClick: this.handleOpen
      }, activeEnvName), isModalOpen && this.renderModal());
    }
  }]);
  return EnvSwitcher;
}(_react.Component);
(0, _defineProperty2["default"])(EnvSwitcher, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(EnvSwitcher, "displayName", 'EnvSwitcher');
//# sourceMappingURL=EnvSwitcher.js.map